const ActiveSign = ({ value} : { value : any}) => {


    return (<>{value === true ? 'Yes' : 'No'}</>)



}

export default ActiveSign;